const state = () => ({
    searchParam:{
        searchKeywords:null,
        map:null
    }
  })
export default state
